<!-- 项目文件 -->
<template>
    <div class="posre">
        <Header1 :img="bgImg"></Header1>
        <div class="w100p bgfff">
            <div class="pt30 pb20 w1200 mauto">
                <div class="textc mt20 mb20 ">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            新闻动态
                        </span>
                    </p>
                </div>
                <div class="textc border2 pt16 pb16">
                    <span class="fs20 c666 ml20 mr20 cursor" @click="activeIndex(0)" :class="{'active':index==0}">公司动态</span>
                    <span class="fs20 c666 ml20 mr20 cursor" @click="activeIndex(1)" :class="{'active':index==1}">行业动态</span>
                   
                </div>
                <div class="overflow">
                    
                        <div class="icon-plus pl16 pr16 pt10  overflow floatl w70p" v-if="index == 0">
                            <ul class="">
                                <li class="bgf6 pl30 pt30 pb30 pr30 mt20" v-if="item.type==0" v-for="(item,index) in CompanyNews" :key="index">
                                    <p @click="Todetail(item.id)" class="fs20 c1f8 fbold tit1 cursor"> {{item.title}} </p>
                                    <p class="fs14 c999 pt20 pb20">{{ item.create_time| formatDate}}</p>
                                    <p class="overflow">
                                        <span class="fs16 c333 disinblock over_3">
                                        {{item.description}}
                                        </span>
                                        <span class="disinblock floatr fs14 c1f8 pt10 h14 lh14 cursor" @click="Todetail(item.id)">
                                            <i class="mr5">详情</i>
                                            <img class="w12 h12" src="../../public/img/img166.png" alt="">
                                        </span>
                                    </p>
                                </li>

                               
                            </ul>
                        </div>
                 
                        <div class="icon-plus pl16 pr16 pt10  overflow floatl w70p" v-if="index == 1">
                            <li class="bgf6 pl30 pt30 pb30 pr30 mt20" v-if="item.type==1" v-for="(item,index) in CompanyNews" :key="index">
                                <p class="fs20 c1f8 fbold cursor tit1 " @click="Todetail(item.id)"> {{item.title}} </p>
                                <p class="fs14 c999 pt20 pb20">{{ item.create_time| formatDate}}</p>
                                <p class="overflow">
                                    <span class="fs16 c333 disinblock over_3">
                                        {{item.description}}
                                    </span>
                                    <span class="disinblock floatr fs14 c1f8 pt10 h14 lh14 cursor" @click="Todetail(item.id)">
                                        <i class="mr5">详情</i>
                                        <img class="w12 h12" src="../../public/img/img166.png" alt="">
                                    </span>
                                </p>
                            </li>
                        </div>
                        

                        <div class="floatr w25p baee mt40">
                            <div class="pt16 pb16 bgf6">
                                <p class="textindent fs16 c000">热点排行榜</p>
                            </div>
                            <div class="pl16 pr16 pb16">
                                <ul>
                                    <p class="overflow mt20 mb20 cursor" @click="Todetail(item.id)" v-for="(item,index) in CompanyNews.slice(0,1)" :key="index">
                                        <span class=" disinblock floatl w48p">
                                            <i class="bgf351 w20 h20 floatl textc lh20 cfff fs12 br50"> 1 </i>
                                            <span class="  alit floatr">
                                                <img class=" w100  h80 " :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png'">
                                            </span>
                                        </span>
                                        <span class="disinblock floatr w48p">
                                            <span class="fs14 c333 disblock"> {{item.title}} </span>
                                            <span class="disblock pt8 pb8 fs12 ccccc">
                                                {{ item.create_time| formatDate}}
                                            </span>
                                            <span class="fs12 c999 over_1 w100p disinblock"> {{item.description}} </span>
                                        </span>
                                    </p>
                                    <li class="overflow mt12 mb15 alit posre cursor" @click="Todetail(item.id)" v-for="(item,index) in CompanyNews.slice(1,9)" :key="index">
                                        <i class="bgf351 w20 h20  textc lh20 cfff fs12 br50 floatl" > {{index+2}} </i>
                                        <span class="fs14 c333 disblock floatl ml16 over_1 w140"> {{item.title}} </span>
                                        <span class="fs12 ccccc disblock floatr posab right0"> {{ item.create_time| formatDate}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                   
                </div>
               
            </div>
        </div>
    
    <Footer></Footer>
    </div>
</template>

<script>
    import Header1 from '@/components/Header1'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img165.png'),
                index: 0,
                CompanyNews: []
            };
        },
        components: {
            Header1,
            Footer,
        },
        mounted() {

        },
        methods: {
            activeIndex(id) {
                this.index = id
            },
            getNews() {
                let that = this;

                $.ajax({
                    type: "POST",
                    url: "https://www.yixueyijia.com/product/news.json",
                    dataType: "json",
                    async: false,
                    data: {
                        "class_id ": 9,
                    },
                    success: function(data) {
                        that.CompanyNews = data.obj;
                        console.log(data.obj);
                        that.$forceUpdate()
                        that.$store.dispatch('Companynewsment').then(() => {
                            that.$store.state.CompanynewsDetail = that.CompanyNews;
                        });

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            Todetail(id) {
                let that = this;
                this.$router.push({
                    path: "/AboutNewsdetail",
                    query: {
                        news_id: id,
                    }
                });
            },
        },

        filters: {
            formatDate(value) {
                var d = new Date(parseInt(value) * 1000);
                return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' +
                    (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
            }
        },
        created() {
            this.getNews()
        },
    }
</script>
<style scoped>
    .tit1:hover {
        color: #333;
    }
</style>